import { normalizeImagePosition } from "../landingStudio/segmentVisualStyle";
import { createNavbarVisualOwnershipDefaults, materializeLegacyNavbarOwnership } from "../landingStudio/navbarVisualOwnership";
import { createMegaMenuVisualDefaults, materializeMegaMenuVisual } from "../landingStudio/megaMenuVisualOwnership";
import { IMAGE_CAROUSEL_VISUAL_DEFAULTS, TESTIMONIALS_VISUAL_DEFAULTS, materializeCarouselTestimonialsOwnership } from "../landingStudio/sectionVisualOwnership";

const NAVBAR_VISUAL_DEFAULTS = createNavbarVisualOwnershipDefaults({}, { style: "style-1" }, {});
const MEGA_MENU_VISUAL_DEFAULTS = createMegaMenuVisualDefaults({}, {}, { megaMenuStyle: "auto" });

export const BRAND = {
  orange: "#F35A3A",
  dark: "#19242F",
  purple: "#6957E8",
  green: "#26A269",
  blue: "#2878D4",
  yellow: "#FFC857",
};


export const emptySettings = {
  schemaVersion: 21,
  publicStatus: "draft",
  revision: 1,
  experienceDefaults: { overrides: [] },
  business: {
    name: "Mi negocio",
    shortDescription: "",
    whatsapp: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    province: "",
    country: "Argentina",
    schedule: "",
    mapEmbedUrl: "",
    socials: {
      instagram: "",
      facebook: "",
      tiktok: "",
      linkedin: "",
      youtube: "",
      website: "",
    },
  },
  navigation: {
    style: "style-1",
    shellStyle: NAVBAR_VISUAL_DEFAULTS.shellStyle,
    barStyle: NAVBAR_VISUAL_DEFAULTS.barStyle,
    topbarStyle: NAVBAR_VISUAL_DEFAULTS.topbarStyle,
    logoSurfaceStyle: NAVBAR_VISUAL_DEFAULTS.logoSurfaceStyle,
    businessNameStyle: NAVBAR_VISUAL_DEFAULTS.businessNameStyle,
    links: NAVBAR_VISUAL_DEFAULTS.links,
    loginStyles: NAVBAR_VISUAL_DEFAULTS.loginStyles,
    accountStyles: NAVBAR_VISUAL_DEFAULTS.accountStyles,
    cartStyles: NAVBAR_VISUAL_DEFAULTS.cartStyles,
    mobile: NAVBAR_VISUAL_DEFAULTS.mobile,
    homeUrl: "/",
    showAboutLink: true,
    aboutLabel: "Sobre nosotros",
    aboutUrl: "#about",
    showHighlightsLink: true,
    highlightsLabel: "Por qué elegirnos",
    highlightsUrl: "#highlights",
    productsUrl: "/productos",
    contactUrl: "/contact",
    loginUrl: "/login",
    showProductsLink: true,
    showContactLink: true,
    showCart: true,
    showCustomerAccess: true,
    showSocialLinks: true,
    showLogo: true,
    homeLabel: "Inicio",
    productsLabel: "Productos",
    allProductsLabel: "Ver todos",
    megaMenuStyle: "auto",
    megaMenuContent: "auto",
    megaMenuDisplay: "both",
    megaMenuHierarchy: "category-first",
    megaMenuVisual: MEGA_MENU_VISUAL_DEFAULTS,
    showMegaMenuIntro: false,
    showMegaMenuStats: false,
    showMegaMenuLatest: false,
    megaMenuEyebrow: "",
    megaMenuTitle: "",
    megaMenuDescription: "",
    megaMenuCategoriesSubtitle: "",
    megaMenuSortLabel: "",
    megaMenuLatestLabel: "Nuevos",
    contactLabel: "Contacto",
    loginLabel: "Iniciar sesión",
    accountLabel: "Mi cuenta",
    logoutLabel: "Cerrar sesión",
    cartLabel: "Ver carrito",
    cartTooltip: "Carrito",
    socialTitle: "Redes sociales",
    loadingCategoriesText: "Cargando categorías…",
    emptyCategoriesText: "No hay categorías todavía.",
    categoriesErrorText: "No se pudieron cargar las categorías.",
    menuAriaLabel: "Abrir menú",
    closeMenuAriaLabel: "Cerrar menú",
    cartAriaLabel: "Abrir carrito",
    buttons: [],
  },
  hero: {
    eyebrow: "",
    title: "Mi negocio",
    subtitle: "",
    primaryCtaLabel: "Consultar",
    primaryCtaUrl: "/contact",
    primaryCtaRequiresProducts: false,
    primaryCtaShowIcon: true,
    primaryCtaIcon: "explore",
    secondaryCtaLabel: "Ver productos",
    secondaryCtaUrl: "/productos",
    secondaryCtaRequiresProducts: true,
    secondaryCtaShowIcon: true,
    secondaryCtaIcon: "storefront",
    imageUrl: "",
    slides: [],
    rotatingPhrases: [],
    overlay: "linear-gradient(to bottom, rgba(0,0,0,.14), rgba(8,8,20,.72))",
    imagePosition: "center",
    contentHorizontalAlign: "left",
    contentVerticalAlign: "center",
  },
  catalog: {
    mode: "auto",
    homeSource: "catalog",
    productsPage: {
      eyebrow: "",
      title: "",
      productsTitle: "Productos",
      servicesTitle: "Servicios",
      hybridTitle: "Productos + servicio",
      subtitle: "",
      loadingText: "Cargando catálogo…",
      resultSingular: "resultado",
      resultPlural: "resultados",
      searchPlaceholder: "Buscar por nombre, servicio, código, categoría o subcategoría",
      showSearch: true,
      showFilters: true,
      showCategoryFilter: true,
      showSubcategoryFilter: true,
      showTypeFilter: true,
      filtersLabel: "Filtros",
      typeFilterLabel: "Tipo",
      categoryFilterLabel: "Categoría",
      subcategoryFilterLabel: "Subcategoría",
      allTypesLabel: "Productos y servicios",
      allCategoriesLabel: "Todas las categorías",
      allSubcategoriesLabel: "",
      resetLabel: "Limpiar filtros",
      emptyTitle: "No encontramos resultados",
      emptyText: "Probá con otra búsqueda o quitá los filtros activos.",
      emptyResetLabel: "Ver todo el catálogo",
      applyFiltersLabel: "Aplicar filtros",
      loadMoreLabel: "Cargar más",
      paginationMode: "all",
      pageSize: 24,
      sortBy: "createdAt",
      sortDir: "desc",
      backgroundColor: "",
      surfaceColor: "",
      textColor: "",
      mutedTextColor: "",
      headerBackgroundColor: "",
      headerTextColor: "",
    },
    productPage: {
      backLabel: "Volver al catálogo",
      homeLabel: "",
      catalogLabel: "",
      additionalInfoTitle: "Información adicional",
      showBreadcrumbs: true,
      showStock: true,
      showAttributes: true,
      showCapabilities: true,
      showQuickCart: true,
      showWhatsapp: true,
      descriptionCollapsedLines: 6,
      descriptionMoreLabel: "Ver más",
      descriptionLessLabel: "Ver menos",
      layout: "split",
      imageFit: "contain",
      backgroundColor: "",
      surfaceColor: "",
      textColor: "",
      mutedTextColor: "",
    },
    cards: {
      gap: 18,
      radius: 16,
      backgroundColor: "",
      backgroundOpacity: 1,
      backgroundImageUrl: "",
      backgroundImagePosition: "center",
      backgroundImageFit: "cover",
      backgroundImageOpacity: 0.28,
      imagePosition: "top",
      imageFit: "cover",
      imageHeight: 210,
      showImage: true,
      showTitle: true,
      showButton: true,
      showType: true,
      showCategory: true,
      showSubcategory: true,
      showDescription: true,
      showPrice: true,
      showDuration: true,
      showCapabilities: true,
      showQuickCart: true,
      borderColor: "",
      shadowColor: "",
      typeColor: "",
      titleColor: "",
      categoryColor: "",
      subcategoryColor: "",
      descriptionColor: "",
      priceColor: "",
      buttonTextColor: "",
      buttonBackgroundColor: "",
      buttonHoverTextColor: "",
      buttonHoverBackgroundColor: "",
      ctaLabel: "Ver detalle",
      serviceCtaLabel: "Ver y reservar",
      ctaBehavior: "detail",
      ctaUrl: "",
    },
    brands: {
      eyebrow: "",
      title: "Marcas",
      subtitle: "Elegí una marca y explorá el catálogo disponible.",
      loadingText: "Cargando marcas…",
      emptyText: "Todavía no hay marcas para mostrar.",
      errorText: "No se pudieron cargar las marcas.",
      ctaLabel: "Ver productos",
      items: [],
    },
    spotlight: {
      enabled: false,
      eyebrow: "",
      title: "",
      description: "",
      logoUrl: "",
      logoAlt: "",
      backgroundImageUrl: "",
      backgroundImagePosition: "center",
      ctaLabel: "",
      ctaUrl: "",
      ctaRequiresProducts: false,
      primaryColor: "",
      secondaryColor: "",
    },
    featured: {
      eyebrow: "",
      title: "Productos destacados",
      subtitle: "Conocé las últimas novedades del catálogo.",
      loadingText: "Cargando productos…",
      emptyText: "Todavía no hay productos para mostrar.",
      errorText: "No se pudieron cargar los productos.",
      ctaLabel: "Ver detalle",
      backgroundColor: "#FFFFFF",
      eyebrowColor: "#F35A3A",
      titleColor: "#19242F",
      subtitleColor: "#5B5D73",
      loadingTextColor: "#5B5D73",
      emptyTextColor: "#1A1A2E",
      errorTextColor: "#D0333A",
    },
    categories: {
      eyebrow: "",
      title: "Explorá por categorías",
      subtitle: "",
      loadingText: "Cargando categorías…",
      emptyText: "Todavía no hay categorías para mostrar.",
      errorText: "No se pudieron cargar las categorías.",
      ctaLabel: "Ver productos",
      productSingular: "producto",
      productPlural: "productos",
      backgroundColor: "#EEF0F5",
      backgroundImageUrl: "",
      backgroundImagePosition: "center",
      eyebrowColor: "#F35A3A",
      titleColor: "#19242F",
      subtitleColor: "#5B5D73",
      loadingTextColor: "#5B5D73",
      loadingSpinnerColor: "#E44E31",
      emptyBackgroundColor: "#E5F6FD",
      emptyTextColor: "#014361",
      emptyBorderColor: "transparent",
      emptyIconColor: "#0288D1",
      errorBackgroundColor: "#FDEDED",
      errorTextColor: "#5F2120",
      errorBorderColor: "transparent",
      errorIconColor: "#D32F2F",
      cardBackgroundColor: "#F7F8FC",
      cardBorderColor: "rgba(26,26,46,.09)",
      cardBorderRadius: 14,
      cardShadowColor: "#272A40",
      cardShadowOpacity: 0.12,
      cardShadowX: 6,
      cardShadowY: 6,
      cardShadowBlur: 16,
      cardShadowSpread: 0,
      imageFit: "cover",
      imagePosition: "center",
      fallbackStartColor: "#494A98",
      fallbackEndColor: "#E44E31",
      fallbackAngle: 135,
      overlayTopColor: "rgba(0,0,0,.14)",
      overlayMiddleColor: "rgba(0,0,0,.12)",
      overlayBottomColor: "rgba(0,0,0,.76)",
      cardTitleColor: "#FFFFFF",
      cardTitleShadowColor: "#000000",
      cardTitleShadowOpacity: 0.55,
      cardTitleShadowX: 0,
      cardTitleShadowY: 3,
      cardTitleShadowBlur: 14,
      countBackgroundColor: "#F35A3A",
      countTextColor: "#FFFFFF",
      countBorderColor: "transparent",
      ctaBackgroundColor: "#F35A3A",
      ctaTextColor: "#FFFFFF",
      ctaHoverBackgroundColor: "#D94D32",
      ctaHoverTextColor: "#FFFFFF",
      ctaBorderColor: "transparent",
      ctaBorderRadius: 999,
    },
  },
  about: {
    eyebrow: "Sobre nuestro negocio",
    title: "Conocé nuestro negocio",
    description: "Trabajamos para ofrecer una atención cercana, soluciones claras y una experiencia confiable en cada consulta.",
    imageUrl: "",
    imageAlt: "Conocé nuestro negocio",
    layout: "image-left",
    imagePosition: "center",
    ctaLabel: "Contactanos",
    ctaUrl: "#contact",
    ctaRequiresProducts: false,
    backgroundColor: "#EEF0F5",
    contentBackgroundColor: "transparent",
    contentBorderRadius: 40,
    eyebrowColor: "#F35A3A",
    titleColor: "#19242F",
    descriptionColor: "#5B5D73",
    descriptionToggleColor: "#F35A3A",
    imageStyle: {
      backgroundColor: "rgba(25,36,47,.06)", borderRadius: 50,
      shadowColor: "#000000", shadowOpacity: 0.15, shadowX: 0, shadowY: 24, shadowBlur: 70, shadowSpread: 0,
    },
    ctaStyle: {
      backgroundColor: "#F35A3A", textColor: "#FFFFFF", hoverBackgroundColor: "#E05335", hoverTextColor: "#EBEBEB",
      borderColor: "transparent", borderWidth: 0, borderRadius: 999,
      shadowColor: "#141628", shadowOpacity: 0.14, shadowX: 0, shadowY: 8, shadowBlur: 20, shadowSpread: 0,
      hoverShadowColor: "#141628", hoverShadowOpacity: 0.2, hoverShadowX: 0, hoverShadowY: 12, hoverShadowBlur: 28, hoverShadowSpread: 0,
      focusRingColor: "#F35A3A18",
    },
  },
  highlightsIntro: {
    eyebrow: "Por qué elegirnos",
    title: "Una experiencia pensada para vos",
    subtitle: "Combinamos atención, calidad y agilidad para que cada contacto con el negocio sea simple y confiable.",
    backgroundColor: "#FFFFFF",
    backgroundImageUrl: "",
    backgroundImagePosition: "center",
    backgroundImageOpacity: 0.24,
    eyebrowColor: "#F35A3A",
    titleColor: "#19242F",
    subtitleColor: "#5B5D73",
  },
  highlights: [
    {
      id: "atencion-personalizada",
      icon: "",
      title: "Atención personalizada",
      description: "Escuchamos cada necesidad y acompañamos al cliente de forma cercana.",
      imageUrl: "",
      imageAlt: "",
      imagePosition: "center",
      youtubeUrl: "",
      backgroundColor: "#FFFFFF",
      iconColor: "#F35A3A",
      titleColor: "#19242F",
      descriptionColor: "#5B5D73",
    },
    {
      id: "calidad-y-confianza",
      icon: "",
      title: "Calidad y confianza",
      description: "Cuidamos cada detalle para brindar una experiencia consistente y segura.",
      imageUrl: "",
      imageAlt: "",
      imagePosition: "center",
      youtubeUrl: "",
      backgroundColor: "#FFFFFF",
      iconColor: "#F35A3A",
      titleColor: "#19242F",
      descriptionColor: "#5B5D73",
    },
    {
      id: "respuesta-agil",
      icon: "",
      title: "Respuesta ágil",
      description: "Facilitamos la consulta y damos respuestas claras para avanzar sin vueltas.",
      imageUrl: "",
      imageAlt: "",
      imagePosition: "center",
      youtubeUrl: "",
      backgroundColor: "#FFFFFF",
      iconColor: "#F35A3A",
      titleColor: "#19242F",
      descriptionColor: "#5B5D73",
    },
  ],
  imageCarousel: {
    eyebrow: "Galería",
    title: "Imágenes que hablan por nosotros",
    subtitle: "Mostrá productos, trabajos, espacios o momentos del negocio.",
    items: [],
    autoplay: true,
    intervalMs: 4500,
    showArrows: true,
    showDots: true,
    ...IMAGE_CAROUSEL_VISUAL_DEFAULTS,
  },
  testimonials: {
    eyebrow: "Testimonios",
    title: "Lo que dicen nuestros clientes",
    subtitle: "Experiencias reales de personas que ya eligieron el negocio.",
    items: [],
    ...TESTIMONIALS_VISUAL_DEFAULTS,
  },
  contact: {
    title: "Contacto",
    subtitle: "",
    whatsappMessage: "Hola, quiero hacer una consulta.",
    backgroundImageUrl: "",
    backgroundImagePosition: "center",
    detailsCtaLabel: "Ver contacto",
    detailsCtaUrl: "/contact",
    whatsappCtaLabel: "Escribir por WhatsApp",
    floatingWhatsappAriaLabel: "Contactar por WhatsApp",
    mapTitle: "Ubicación",
    backgroundColor: "#19242F",
    imageBackgroundColor: "rgba(255,255,255,.08)",
    decorativeAccentColor: "#F35A3A",
    titleColor: "#FFFFFF",
    subtitleColor: "rgba(255,255,255,.82)",
    addressTextColor: "rgba(255,255,255,.82)",
    scheduleTextColor: "rgba(255,255,255,.82)",
    phoneTextColor: "rgba(255,255,255,.82)",
    emailTextColor: "rgba(255,255,255,.82)",
    addressIconColor: "#F35A3A",
    scheduleIconColor: "#F35A3A",
    phoneIconColor: "#F35A3A",
    emailIconColor: "#F35A3A",
    detailsCtaStyle: { textColor: "#FFFFFF" },
  },
  footer: {
    style: "style-1",
    showLogo: true,
    logoPosition: "center",
    tagline: "",
    copyright: "{businessName}. Todos los derechos reservados.",
    navigationTitle: "Navegación",
    contactTitle: "Contacto",
    homeLabel: "Inicio",
    productsLabel: "Productos",
    contactLabel: "Contacto",
  },
  messages: {
    maintenanceTitle: "Estamos actualizando el sitio",
    maintenanceDescription: "{businessName} se encuentra temporalmente en mantenimiento.",
    unavailableTitle: "Sitio no disponible",
    unavailableDescription: "La presencia pública de este proyecto todavía no está habilitada.",
    catalogDisabledTitle: "Catálogo no disponible",
    catalogDisabledDescription: "El catálogo no está habilitado para este sitio.",
    ordersDisabledTitle: "Pedidos no disponibles",
    ordersDisabledDescription: "Podés consultar el catálogo y comunicarte directamente con el comercio.",
    ecommerceDisabledTitle: "Pago online no disponible",
    ecommerceDisabledDescription: "El pedido puede coordinarse directamente con el comercio.",
  },
  notifications: {
    webPushPrompt: {
      enabled: true,
      title: "Recibí novedades",
      subscribedTitle: "Notificaciones activadas",
      description: "Activá los avisos de {businessName} para enterarte de novedades y promociones.",
      subscribedDescription: "Este navegador recibe avisos de {businessName}.",
      enableLabel: "Activar notificaciones",
      disableLabel: "Desactivar",
      dismissLabel: "Ahora no",
      processingLabel: "Procesando…",
      successMessage: "Notificaciones activadas correctamente.",
      disableSuccessMessage: "Notificaciones desactivadas.",
      errorMessage: "No se pudieron activar las notificaciones.",
      disableErrorMessage: "No se pudieron desactivar las notificaciones.",
      position: "bottom-right",
      backgroundColor: "",
      textColor: "",
      mutedTextColor: "",
    },
  },
  theme: {
    template: "catalog-basic",
    primaryColor: "#F35A3A",
    secondaryColor: "#19242F",
    surfaceColor: "#F7F8FC",
    backgroundColor: "#EEF0F5",
    textColor: "#1A1A2E",
    mutedTextColor: "#5B5D73",
    dividerColor: "rgba(26,26,46,.09)",
    logoUrl: "",
    compactLogoUrl: "",
    faviconUrl: "",
    fontFamily: "Asap",
    headingFontFamily: "Exo 2",
    bodyFontFamily: "Asap",
    googleFontsUrl: "",
    fonts: [],
    borderRadius: 10,
    mode: "light",
  },
  seo: { title: "", description: "", imageUrl: "" },
  sections: {
    showNavbar: true,
    showHero: true,
    showSpotlight: true,
    showBrands: true,
    showProducts: true,
    showFeatured: true,
    showCategories: true,
    showAbout: true,
    showHighlights: true,
    showImageCarousel: false,
    showTestimonials: false,
    showContact: true,
    showFooter: true,
    showFloatingWhatsapp: true,
  },
  layout: {
    segments: [
      { id: "navbar", type: "navbar" },
      { id: "hero", type: "hero" },
      { id: "spotlight", type: "spotlight" },
      { id: "featured", type: "featured" },
      { id: "brands", type: "brands" },
      { id: "categories", type: "categories" },
      { id: "about", type: "about" },
      { id: "highlights", type: "highlights" },
      { id: "contact", type: "contact" },
      { id: "footer", type: "footer" },
    ],
  },
  updatedAt: null,
};

function clone(value) {
  if (typeof structuredClone === "function") return structuredClone(value);
  return JSON.parse(JSON.stringify(value));
}

function deepMerge(base, source) {
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return source === undefined ? clone(base) : clone(source);
  }

  const output = clone(base);
  Object.entries(source).forEach(([key, value]) => {
    if (
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      base?.[key] &&
      typeof base[key] === "object" &&
      !Array.isArray(base[key])
    ) {
      output[key] = deepMerge(base[key], value);
    } else if (value !== undefined) {
      output[key] = clone(value);
    }
  });
  return output;
}

function pickSettings(payload = {}) {
  const root = payload?.data?.data || payload?.data || payload || {};
  return root?.settings || root?.landing || root || {};
}

function imageCarouselSnapshotHasContent(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  if (String(value.eyebrow || "").trim()) return true;
  if (String(value.title || "").trim()) return true;
  if (String(value.subtitle || "").trim()) return true;
  return Array.isArray(value.items) && value.items.some((item) =>
    Boolean(String(item?.imageUrl || "").trim() || String(item?.caption || "").trim())
  );
}

function repairImageCarouselLayout(input = {}) {
  const source = clone(input || {});
  const segments = Array.isArray(source.layout?.segments) ? source.layout.segments : [];
  const carouselEntries = segments
    .map((segment, index) => ({ segment, index }))
    .filter(({ segment }) => String(segment?.type || segment?.id || "") === "imageCarousel");

  if (!carouselEntries.length) return source;

  const canonical = carouselEntries.find(({ segment }) => String(segment?.id || "") === "imageCarousel") || null;
  const duplicateWithContent = carouselEntries.find(({ segment }) =>
    String(segment?.id || "") !== "imageCarousel" &&
    segment?.visible !== false &&
    imageCarouselSnapshotHasContent(segment?.data?.imageCarousel)
  ) || carouselEntries.find(({ segment }) =>
    String(segment?.id || "") !== "imageCarousel" &&
    imageCarouselSnapshotHasContent(segment?.data?.imageCarousel)
  ) || null;

  const rootHasContent = imageCarouselSnapshotHasContent(source.imageCarousel);
  const primary = rootHasContent && canonical ? canonical : (duplicateWithContent || canonical || carouselEntries[0]);
  const primarySnapshot = primary?.segment?.data?.imageCarousel;

  if (primarySnapshot && typeof primarySnapshot === "object" && !Array.isArray(primarySnapshot)) {
    source.imageCarousel = deepMerge(source.imageCarousel || {}, primarySnapshot);
  }

  source.sections = source.sections && typeof source.sections === "object" && !Array.isArray(source.sections)
    ? { ...source.sections }
    : {};
  const anyVisibleCarousel = carouselEntries.some(({ segment }) => segment?.visible !== false);
  source.sections.showImageCarousel = source.sections.showImageCarousel !== false || anyVisibleCarousel;

  const canonicalSegment = {
    ...(primary?.segment || {}),
    id: "imageCarousel",
    type: "imageCarousel",
  };
  delete canonicalSegment.data;
  delete canonicalSegment.visible;

  const primaryIndex = Math.max(0, Number(primary?.index ?? carouselEntries[0]?.index ?? 0));
  const insertionIndex = segments
    .slice(0, primaryIndex)
    .filter((segment) => String(segment?.type || segment?.id || "") !== "imageCarousel")
    .length;
  const withoutCarousels = segments.filter((segment) =>
    String(segment?.type || segment?.id || "") !== "imageCarousel"
  );
  withoutCarousels.splice(Math.min(insertionIndex, withoutCarousels.length), 0, canonicalSegment);

  source.layout = {
    ...(source.layout && typeof source.layout === "object" ? source.layout : {}),
    segments: withoutCarousels,
  };

  return source;
}


function hasVisualValue(value) {
  return value !== undefined && value !== null && !(typeof value === "string" && value.trim() === "");
}

function visualValue(...values) {
  return values.find(hasVisualValue);
}

function setIfMissing(target, key, value) {
  if (!target || hasVisualValue(target[key]) || value === undefined) return;
  target[key] = clone(value);
}

function materializeLegacyAppearance(input = {}, inheritedTheme = {}) {
  const source = clone(input || {});
  const appearance = source.appearance && typeof source.appearance === "object" ? source.appearance : {};
  const theme = source.theme && typeof source.theme === "object" ? source.theme : (inheritedTheme || {});

  const highlightsLegacy = appearance.highlights && typeof appearance.highlights === "object" ? appearance.highlights : {};
  if (Object.prototype.hasOwnProperty.call(appearance, "highlights")) {
    source.highlightsIntro = source.highlightsIntro && typeof source.highlightsIntro === "object" ? source.highlightsIntro : {};
    const accent = visualValue(highlightsLegacy.accentColor, theme.primaryColor, "#F35A3A");
    const title = visualValue(highlightsLegacy.titleColor, theme.secondaryColor, "#19242F");
    const body = visualValue(highlightsLegacy.textColor, theme.mutedTextColor, "#5B5D73");
    const card = visualValue(highlightsLegacy.surfaceColor, theme.surfaceColor, "#FFFFFF");
    setIfMissing(source.highlightsIntro, "backgroundColor", visualValue(highlightsLegacy.backgroundColor, theme.surfaceColor, "#FFFFFF"));
    setIfMissing(source.highlightsIntro, "backgroundImageUrl", visualValue(highlightsLegacy.backgroundImageUrl, ""));
    setIfMissing(source.highlightsIntro, "backgroundImagePosition", visualValue(highlightsLegacy.backgroundImagePosition, "center"));
    setIfMissing(source.highlightsIntro, "backgroundImageOpacity", visualValue(highlightsLegacy.backgroundImageOpacity, 0.24));
    setIfMissing(source.highlightsIntro, "eyebrowColor", accent);
    setIfMissing(source.highlightsIntro, "titleColor", title);
    setIfMissing(source.highlightsIntro, "subtitleColor", body);
    source.highlights = Array.isArray(source.highlights) ? source.highlights.map((item) => {
      const next = item && typeof item === "object" ? { ...item } : {};
      setIfMissing(next, "backgroundColor", card);
      setIfMissing(next, "iconColor", accent);
      setIfMissing(next, "titleColor", title);
      setIfMissing(next, "descriptionColor", body);
      return next;
    }) : source.highlights;
  }

  const contactLegacy = appearance.contact && typeof appearance.contact === "object" ? appearance.contact : {};
  if (Object.prototype.hasOwnProperty.call(appearance, "contact")) {
    source.contact = source.contact && typeof source.contact === "object" ? source.contact : {};
    const accent = visualValue(contactLegacy.accentColor, theme.primaryColor, "#F35A3A");
    const text = visualValue(contactLegacy.textColor, "rgba(255,255,255,.82)");
    setIfMissing(source.contact, "backgroundColor", visualValue(contactLegacy.backgroundColor, theme.secondaryColor, "#19242F"));
    setIfMissing(source.contact, "imageBackgroundColor", visualValue(contactLegacy.surfaceColor, "rgba(255,255,255,.08)"));
    setIfMissing(source.contact, "decorativeAccentColor", accent);
    setIfMissing(source.contact, "titleColor", visualValue(contactLegacy.titleColor, "#FFFFFF"));
    setIfMissing(source.contact, "subtitleColor", text);
    ["addressTextColor", "scheduleTextColor", "phoneTextColor", "emailTextColor"].forEach((key) => setIfMissing(source.contact, key, text));
    ["addressIconColor", "scheduleIconColor", "phoneIconColor", "emailIconColor"].forEach((key) => setIfMissing(source.contact, key, accent));
    source.contact.detailsCtaStyle = source.contact.detailsCtaStyle && typeof source.contact.detailsCtaStyle === "object" ? source.contact.detailsCtaStyle : {};
    setIfMissing(source.contact.detailsCtaStyle, "textColor", visualValue(contactLegacy.titleColor, "#FFFFFF"));
  }

  if (Array.isArray(source.layout?.segments)) {
    source.layout = { ...source.layout, segments: source.layout.segments.map((segment) => {
      if (!segment || !["highlights", "contact"].includes(segment.type) || !segment.data) return segment;
      return { ...segment, data: materializeLegacyAppearance(segment.data, theme) };
    }) };
  }
  delete source.appearance;
  return source;
}

export function mergeSettings(payload = {}) {
  const rawSource = repairImageCarouselLayout(pickSettings(payload));
  const sectionOwnershipSource = materializeCarouselTestimonialsOwnership(materializeLegacyAppearance(rawSource, rawSource?.theme));
  const navbarSource = materializeLegacyNavbarOwnership(sectionOwnershipSource);
  const source = {
    ...navbarSource,
    navigation: materializeMegaMenuVisual(navbarSource?.navigation, navbarSource?.theme, navbarSource?.designTokens),
  };
  if (Array.isArray(source.layout?.segments)) {
    source.layout = {
      ...source.layout,
      segments: source.layout.segments.map((segment) => {
        if (!(segment?.id === "navbar" || segment?.type === "navbar") || !segment?.data) return segment;
        const data = { ...segment.data };
        return {
          ...segment,
          data: {
            ...data,
            navigation: materializeMegaMenuVisual(data.navigation, data.theme || source.theme, data.designTokens || source.designTokens),
          },
        };
      }),
    };
  }
  const merged = deepMerge(emptySettings, source);

  merged.schemaVersion = 21;
  merged.revision = Number(source?.revision || merged.revision || 1);
  merged.hero.imagePosition = normalizeImagePosition(merged.hero?.imagePosition);
  merged.hero.slides = Array.isArray(merged.hero?.slides)
    ? merged.hero.slides
        .filter((slide) => slide?.url)
        .map((slide) => ({
          ...slide,
          position: normalizeImagePosition(slide?.position, merged.hero.imagePosition),
        }))
    : [];
  merged.hero.rotatingPhrases = Array.isArray(merged.hero?.rotatingPhrases)
    ? merged.hero.rotatingPhrases.filter(Boolean)
    : [];
  merged.catalog.brands.items = Array.isArray(merged.catalog?.brands?.items)
    ? merged.catalog.brands.items.filter((item) => (item?.name ?? item?.label) || item?.logoUrl)
    : [];
  merged.about.imagePosition = normalizeImagePosition(merged.about?.imagePosition);
  merged.catalog.spotlight.backgroundImagePosition = normalizeImagePosition(
    merged.catalog?.spotlight?.backgroundImagePosition
  );
  merged.imageCarousel.items = Array.isArray(merged.imageCarousel?.items)
    ? merged.imageCarousel.items.filter((item) => item?.imageUrl || item?.caption).map((item) => ({
        ...item,
        imagePosition: normalizeImagePosition(item?.imagePosition),
      }))
    : [];
  merged.testimonials.items = Array.isArray(merged.testimonials?.items)
    ? merged.testimonials.items.filter((item) => item?.quote || item?.name || item?.role || item?.avatarUrl)
    : [];
  merged.contact.backgroundImagePosition = normalizeImagePosition(
    merged.contact?.backgroundImagePosition
  );
  merged.highlightsIntro.backgroundImagePosition = normalizeImagePosition(
    merged.highlightsIntro?.backgroundImagePosition
  );
  const highlightsBackgroundOpacity = Number(merged.highlightsIntro?.backgroundImageOpacity);
  merged.highlightsIntro.backgroundImageOpacity = Number.isFinite(highlightsBackgroundOpacity)
    ? Math.max(0, Math.min(1, highlightsBackgroundOpacity))
    : 0.24;
  merged.footer.logoPosition = normalizeImagePosition(merged.footer?.logoPosition);
  merged.highlights = Array.isArray(merged.highlights)
    ? merged.highlights
        .filter((item) => item?.title || item?.description || item?.imageUrl || item?.youtubeUrl)
        .map((item) => ({
          ...item,
          imagePosition: normalizeImagePosition(item?.imagePosition),
        }))
    : clone(emptySettings.highlights);

  // Una colección explícitamente vacía representa contenido eliminado. Sólo
  // una propiedad ausente hereda los valores iniciales mediante deepMerge.
  return merged;
}
